import { render, staticRenderFns } from "./DeliveryStepPickupOrder.vue?vue&type=template&id=7879a203&"
import script from "./DeliveryStepPickupOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepPickupOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStepPickupOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports